var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-border tw-border-blue-600 tw-text-blue-600 tw-rounded-full tw-w-5 tw-h-5 tw-p-[2px]"},[_c(_vm.computedComponent,{tag:"component",staticClass:"tw-w-full tw-h-full"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }